export default __webpack_public_path__ + "static/media/lubaantunGrid17.59cfd078.webp";